import {useContext, useEffect} from "react";
import {useLocation} from "react-router-dom";
import {Helmet} from "react-helmet-async";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext} from "../../GlobalReducer";
import useYandexMetrika from "../../utils/useYandexMetrika";

export default function MetaParams() {
    const [state] = useContext<[ReducerStateInterface, Function]>(GlobalContext);
    const {hit} = useYandexMetrika();

    const location = useLocation()

    useEffect(() => {
        const params = state.customer
            ? { params: { customer_id: state.customer.id, customer_name: state.customer.name } }
            : undefined;
        hit(window.location.href, params);
    }, [location.pathname, location.search]);

    const getCanonical = () => {
        let canonical = 'https://b2b.pride.ru' + window.location.pathname;
        return canonical
    }

    // defaultTitle — запасной заголовок: helmet не трогает document.title, если значения нет,
    // поэтому без него заголовок «залипает» от прошлой страницы после ухода с товара/категории
    return (<Helmet defaultTitle="Главная">
        { /* Standard metadata tags */}
        {state.meta?.title && <title>{state.meta.title}</title>}
        {state.meta?.description && <meta name="description" content={state.meta.description}/>}
        {state.meta?.meta_tags && state.meta.meta_tags.map(tag => tag.name !== 'canonical' &&
            <meta name={tag.name} content={tag.value}/>
        )}
        <link rel="canonical" href={getCanonical()}/>

        <meta property="og:title" content={state.meta?.html_header || state.meta?.title}/>
        <meta property="og:type" content={'website'}/>
        <meta property="og:description" content={state.meta?.description}/>
        <meta property="og:url" content={"https://b2b.pride.ru" + location.pathname}/>
        <meta property="og:locale" content="ru_RU"/>
        <meta property="og:image" content={state.meta?.image || "https://b2b.pride.ru/public/new-design/main/top-logo.svg"}/>
        <meta property="og:site_name" content="Pride"/>

    </Helmet>)

}